import {
  DELETE_EDI_RECORD_REQUEST,
  DELETE_EDI_RECORD_SUCCESS,
  DELETE_EDI_RECORD_FAILURE,
  CLEAR_RECORD_DELETED_POPUP,
} from "../actionTypes";

const intialState = {
  loading: false,
  recordDeleted: [],
  error: "",
};

const deleteRecordReducer = (state = intialState, action) => {
  switch (action.type) {
    case DELETE_EDI_RECORD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_EDI_RECORD_SUCCESS:
      return {
        loading: false,
        recordDeleted: action.payload,
        error: "",
      };
    case CLEAR_RECORD_DELETED_POPUP:
      return {
        ...state,
        recordDeleted: [],
      };
    case DELETE_EDI_RECORD_FAILURE:
      return {
        loading: false,
        recordDeleted: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export default deleteRecordReducer;
